import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { FeedType, SportEvent } from "@/types/SportsApiResponses";

export interface GetMarketMatchesParams {
  id: number;
  lang: string;
  feedType: FeedType;
  providerId: number;
}

export const getMarketMatches = async (
  props: QueryProps<GetMarketMatchesParams>
): Promise<
  | {
      sportEvent: SportEvent;
      matchMarkets: Record<
        string,
        {
          is_active: boolean;
          adjusted_by: number;
        }
      >;
    }
  | undefined
> => {
  const { id, ...queryParams } = props.params;
  const res = await api.client.get(`/matches/markets/${id}`, {
    signal: props.signal,
    params: queryParams,
  });
  return res.data;
};
